module.exports = __webpack_public_path__ + "static/4-efd7e6ff715603d749a5cd803c151573.png";